/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

export const defaultLocale = "en-US";
export const fallbackLocale = "en-US";
export const locales = [
	"ar",
	"bg",
	"cs",
	"da",
	"de",
	"en-US",
	"es-ES",
	"es-MX",
	"fi",
	"fil",
	"fr",
	"hi",
	"hu",
	"id",
	"it",
	"ja",
	"ko",
	"ms",
	"nl",
	"no",
	"pl",
	"pt",
	"pt-BR",
	"ro",
	"ru",
	"sv",
	"th",
	"tr",
	"uk",
	"vi",
	"zh-CN",
	"zh-Hant",
];
export const hygraphLocales = [
	"ar",
	"bg",
	"cs",
	"da",
	"de",
	"en",
	"es_ES",
	"es_MX",
	"fi",
	"fil",
	"fr",
	"hi",
	"hu",
	"id",
	"it",
	"ja",
	"ko",
	"ms",
	"nl",
	"no",
	"pl",
	"pt",
	"pt_BR",
	"ro",
	"ru",
	"sv",
	"th",
	"tr",
	"uk",
	"vi",
	"zh_CN",
	"zh_TW",
];

export const i18n = {
	fallbackLocale,
	defaultLocale,
	locales,
	hygraphLocales,
};
